
import { data_user } from './datauser'
import { apicode } from './apicode'

export const validarME = {


    async me() {
        const respostame = await data_user.me();
        if (respostame) {



            const { retorno } = respostame.data

          //  console.log(retorno, 'retorno')

            const retorno2 = apicode._decode(retorno);

           // console.log(retorno2, 'retorno2')


            if (retorno2.banido) { return null } else { return retorno2 }
        }
        return null

    }
}
